import { Point } from '../drawing';

export const LOWEST_PITCH = 3;
export const DUMMY_PITCH = (LOWEST_PITCH + 6);
export const LOW_LEDGER_LINE_PITCH = (LOWEST_PITCH + 1);
export const LOW_LINE_PITCH = (LOWEST_PITCH + 3);
export const MAX_PITCH = (LOWEST_PITCH + 4 + (2 * 5));

export const MAX_AMBITUS = 5;
export const NO_KEY = -5;

export const HEPISEMA_FIRST_TWO = 12;
export const NO_PITCH = -128;

export const PositionAdjustments: { [key: number]: Point } = {
  1: Point.create(-1, -1),
  2: Point.create(0, -1),
  3: Point.create(1, -1),
  4: Point.create(-1, 0),
  5: Point.create(0, 0),
  6: Point.create(1, 0),
  7: Point.create(-1, 1),
  8: Point.create(0, 1),
  9: Point.create(1, 1),
};
